import { cn } from '@/lib/utils'

/** The Genorah Labs logo: the owner's SVG with its viewBox cropped to the mark (312 × 284). */
export const LOGO_GENORAH = '/brand/genorah-labs.svg'

interface KreditPengembangProps {
  /** ui.umum.dikembangkanOleh; the public page passes its own copy of it (verifikasi/strings). */
  teks: string
  className?: string
}

/**
 * The developer's credit (release 23, owner 2026-10-14): the Genorah Labs logo, 20 px tall in
 * full colour, then the sentence in `label` muted ink. It is a vendor mark, so it stays small,
 * with no red, glow or shadow, and never competes with SATU's red. It sits under the sign-in
 * card, in Akun › Tentang SATU and at the foot of /periksa. It is never on a print or a download
 * (test/cetak-tanpa-kredit). The logo is an `<img>`, not an inline SVG: two inline copies on one
 * page would share their gradients' ids. It is decorative beside the sentence (`alt=""`), so a
 * screen reader reads the sentence once. The logo sits in the line, as the first word: where the
 * sentence wraps (a 360 px phone), the lines centre or balance with it.
 */
export function KreditPengembang({ teks, className }: KreditPengembangProps) {
  return (
    <p
      data-kredit-pengembang=""
      className={cn('text-label leading-5 font-medium text-balance text-muted', className)}
    >
      <img
        src={LOGO_GENORAH}
        alt=""
        width={22}
        height={20}
        className="mr-2 inline-block h-5 w-auto align-[-0.4em]"
      />
      {teks}
    </p>
  )
}
